// import { createI18n } from 'vue-i18n/dist/vue-i18n.cjs.js'
import { createI18n } from 'vue-i18n'
import xling from './xling'
import chenx from './chenx'
import qpleyou from './qpleyou'

const i18n = createI18n({
	legacy: false,
	locale: 'qpleyou',
	messages: {
		xling: xling,
		chenx: chenx,
		qpleyou: qpleyou
	}
})

export default i18n